@if (isNotNil(externalLink())) {
  <a
    [href]="externalLink()!"
    (click)="handleLinkClick($event)"
    class="block">
    <ng-container [ngTemplateOutlet]="contentRef" />
  </a>
} @else {
  <ng-container [ngTemplateOutlet]="contentRef" />
}

<ng-template #contentRef>
  @let mobileImageSource = mobileImageSrc();
  @let imageSource = imageSrc();

  @if (isNotNil(mobileImageSource)) {
    <div class="relative aspect-[1600/665] md:hidden">
      <ng-container
        [ngTemplateOutlet]="imageTemplateRef"
        [ngTemplateOutletContext]="{ src: mobileImageSource }" />
    </div>

    <div class="relative hidden aspect-[1600/665] md:block">
      <ng-container
        [ngTemplateOutlet]="imageTemplateRef"
        [ngTemplateOutletContext]="{ src: imageSource }" />
    </div>
  } @else {
    <div class="relative aspect-[1600/665]">
      <ng-container
        [ngTemplateOutlet]="imageTemplateRef"
        [ngTemplateOutletContext]="{ src: imageSource }" />
    </div>
  }
</ng-template>

<ng-template
  #imageTemplateRef
  let-src="src">
  <div class="absolute inset-0 size-full">
    <app-image-thumbnail
      [rounded]="false"
      size="full">
      <img
        [alt]="imageAlt()"
        [fill]="true"
        [ngSrc]="src"
        class="object-contain" />
    </app-image-thumbnail>
  </div>
</ng-template>
